import {BaseService} from '../baseService.js';

/* 
 * Handles Unit Group
 */
export class UnitGroupService extends BaseService {

	constructor() {	
		super();
	}
	
	async getUnitGroups(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/unit-groups' + params);
		return data;
	}	

	async getUnitGroup(unitGroupId) {
		var data = await this.makeGETRequest('/api/resource/unit-groups/' + unitGroupId);		
		return data;		
	}	
	
	async saveUnitGroup(unitGroup, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/unit-groups/' + unitGroup.unitGroupId, unitGroup);
		} else {
			saved = await this.makePOSTRequest('/api/resource/unit-groups', unitGroup);
		}
		return saved;
	}	

	async deleteUnitGroup(unitGroupId) {		
		var result = await this.makeDELETERequest('/api/resource/unit-groups/' + unitGroupId);		
		return result;
	}
	
	async activateUnitGroup(unitGroupId) {	
		var result = await this.makePUTRequest('/api/resource/unit-groups/' + unitGroupId + '/activate');
		return result;
	}	

	async inactivateUnitGroup(unitGroupId) {	
		var result = await this.makePUTRequest('/api/resource/unit-groups/' + unitGroupId + '/inactivate');
		return result;
	}	
	
	async resolveGroupUnits(unitGroupId, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var data = await this.makeGETRequest('/api/resource/unit-groups/' + unitGroupId + '/resolve-group-units' + params);
		return data;
	}	
	
	async getGroupHistory(unitGroupId, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var data = await this.makeGETRequest('/api/resource/unit-groups/' + unitGroupId + '/history' + params);
		return data;
	}	
	
	async getGroupHistoryRecord(unitGroupId, unitGroupHistoryId) {
		var data = await this.makeGETRequest('/api/resource/unit-groups/' + unitGroupId + '/history/' + unitGroupHistoryId);
		return data;
	}	
	
	async deleteUnitGroupHistory(unitGroupId, unitGroupHistoryId) {		
		var result = await this.makeDELETERequest('/api/resource/unit-groups/' + unitGroupId + '/history/' + unitGroupHistoryId);		
		return result;
	}
	
	async saveHistory(unitGroupId, history, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/unit-groups/' + unitGroupId + '/history/' + history.unitGroupHistoryId, history);
		} else {
			saved = await this.makePOSTRequest('/api/resource/unit-groups/' + unitGroupId + '/history', history);
		}
		return saved;
	}
	
	exportGroupHistory(unitGroupId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/unit-groups/' + unitGroupId + '/history/export' + params);		
	}	
	
	async updateUnitGroup(unitGroupId, unitsInGroup) {	
		var result = await this.makePUTRequest('/api/resource/unit-groups/' + unitGroupId + '/unit-group-ref', unitsInGroup);
		return result;
	}	
	
	async getMatchingFields(referenceType) {
		var data = await this.makeGETRequest('/api/resource/unit-groups/field-definitions/' + referenceType);
		return data;
	}
	
	async getDirectUnitGroupRef(unitGroupId, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var data = await this.makeGETRequest('/api/resource/unit-groups/' + unitGroupId + '/units' + params);
		return data;
	}
	
	async getAvalibleDirectUnits(unitGroupId, referenceType, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var data = await this.makeGETRequest('/api/resource/unit-groups/' + unitGroupId + '/units/available/' + referenceType + params);
		return data;
	}	
	
	exportUnits(unitGroupId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/unit-groups/' + unitGroupId + '/units/export' + params);		
	}

	exportUnitGroups(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/unit-groups/export' + params);
	}
	
	async addUnitsToGroup(unitGroupId, units) {
		var saved = await this.makePOSTRequest('/api/resource/unit-groups/' + unitGroupId + '/units', units);		
		return saved;
	}
	
	async deleteUnitsInGroup(unitGroupId, unitGroupHistoryIds) {		
		var result = await this.makeDELETERequest('/api/resource/unit-groups/' + unitGroupId + '/units', unitGroupHistoryIds);		
		return result;
	}	
	
	
};